var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.166 3.11c.082.113.155.234.223.361l-.757 3.835-.237 1.194h5.801c.364 0 .667.302.667.666v.9a.627.627 0 0 1-.015.133l-.043.132-.002.005-2.181 5.042a.678.678 0 0 1-.551.288H8.312a.95.95 0 0 1-.949-.94V8.191c0-.176.069-.347.198-.477l4.605-4.605ZM3.696 8.5v7.166h-.5V8.5h.5Z",
    stroke: "#368434",
    strokeWidth: 2
  })));
};

export default SvgLike;